<template>
  <div class="creditor-search">
    <input
      type="text"
      v-model="search"
      class="form-control creditor-search__input"
      @input="onChange"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnterKey"
      @keydown.tab="onEnterKey"
      autocomplete="off"
      placeholder="Search by email or name (at least 3 characters)"
      :class="{
        'is-invalid': !isValid,
      }"
    />
    <ul class="creditor-search__result-list" :class="{ 'is-open': isOpen }">
      <li v-if="isLoading" class="creditor-search__result-item">
        Searching creditor
        <b-spinner/>
      </li>
      <li v-else-if="results.length === 0" class="creditor-search__result-item">
        No Creditors found
      </li>
      <li
        v-else
        v-for="(result, i) in filteredCreditors"
        :key="i"
        class="creditor-search__result-item"
        :class="{
          'is-active': i === arrowCounter,
        }"
        @click="setResult(result)"
      >
        <div>Creditor ID: {{ result.creditorId }}</div>
        <div>Name: {{ result.name }}</div>
        <div v-if="!!result.email">Email : {{ result.email }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import apiAuth from 'src/clients/apiAuth';
import constants from 'src/constants/constants';
import _ from 'lodash';

export default {
  name: 'CreditorSearch',
  data: () => {
    return {
      search: '',
      results: [],
      isOpen: false,
      isLoading: false,
      arrowCounter: -1,
      selected: null,
      isValidSearchInput: false,
    };
  },
  props: ['isValid', 'purchaseOfferUserEmail'],
  methods: {
    searchCreditor() {
      let options = {
        method: 'GET',
        url: constants.url.userService.baseUrl + '/api/v1/suppliers?query=' + this.search.trim().toLowerCase(),
      };

      return apiAuth(options)
        .then((response) => {
          this.isLoading = false;
          this.results = response.data;
          return response.data;
        })
        .catch((error) => {
          console.log('user_service_api error');
          console.log(error);
        });
    },
    onChange: _.debounce(function() {
      this.isValidSearchInput = false;
      if (this.search.length < 3) {
        this.results = [];
        this.isOpen = false;
        return;
      }
      this.isLoading = true;
      this.searchCreditor();
      this.isOpen = true;
    }, 500),
    onArrowDown() {
      if (this.arrowCounter < this.results.length - 1) {
        this.arrowCounter++;
      }
      this.scrollList();
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter--;
      }
      this.scrollList();
    },
    onEnterKey() {
      let counter = 0;
      if (this.arrowCounter >= 0) {
        counter = this.arrowCounter;
      }
      this.setResult(this.results[counter]);
    },
    setResult(result) {
      this.isOpen = false;
      this.arrowCounter = -1;
      this.$emit('creditorSelected', result || null);
      if (result) {
        this.search = result.creditorId;
        this.isValidSearchInput = true;
      } else {
        this.search = '';
        this.isValidSearchInput = false;
      }
    },
    scrollList() {
      if (this.arrowCounter < 0) return;

      // eslint-disable-next-line no-undef
      $('.creditor-search__result-list').scrollTop(
        // eslint-disable-next-line no-undef
        this.arrowCounter * $('.creditor-search__result-item').outerHeight(),
      );
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target) && this.isValidSearchInput === false) {
        this.setResult(null);
      }
    },
  },
  computed: {
    filteredCreditors() {
      return this.results.filter((creditor) => {
        return creditor.creditorId !== null;
      });
    },
  },
  mounted() {
    this.$parent.$el.addEventListener('click', this.handleClickOutside);

    let optionsUser = {
      method: 'GET',
      url: constants.url.userService.baseUrl + '/api/v1/users/byEmail/' + this.purchaseOfferUserEmail.toLowerCase(),
    };

    apiAuth(optionsUser)
      .then((response) => {
        if (response.data.length === 0) {
          return Promise.reject('Did not find user by email ' + this.purchaseOfferUserEmail.toLowerCase());
        }
        if (!response.data[0].supplierId || 'null' === response.data[0].supplierId) {
          return Promise.reject('User does not have an supplierId: ' + this.purchaseOfferUserEmail.toLowerCase());
        }
        return response.data[0].supplierId;
      })
      .then((supplierId) => {
        let optionsSupplier = {
          method: 'GET',
          url:
            constants.url.userService.baseUrl +
            '/api/v1/suppliers/' +
            supplierId +
            '/?fields=currencyCode,creditorId,isTaxLiable,name',
        };
        return apiAuth(optionsSupplier);
      })
      .then((response) => {
        if (response.data.length === 0) {
          return;
        }
        this.setResult(response.data);
      })
      .catch((error) => {
        console.log('user_service_api error');
        console.log(error);
      });
  },
  destroyed() {
    this.$parent.$el.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style lang="scss" scoped>
.creditor-search {
  position: relative;

  &__result-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    list-style: none;
    margin: 0;
    padding: 0;
    background: #fff;
    border: none;
    z-index: 2;
    overflow: auto;
    height: 0;
    max-height: 300px;

    &.is-open {
      height: auto;
      border: 1px solid #ccc;
      border-top: none;
    }
  }

  &__result-item {
    border-bottom: 1px solid #ccc;
    padding: 0.25em 0.5em;

    &:last-child {
      border-bottom: none;
    }

    &:hover,
    &.is-active {
      cursor: pointer;
      background: orange;
    }
  }
}
</style>
